
































































































import Component from 'vue-class-component'
import { Prop, Vue, Watch } from 'vue-property-decorator'
import PriceConfig from '@/dto/price_config/PriceConfig'
import Currency from '@/dto/deliveries/Currency'
import DictionariesService from '@/services/DictionariesService'
import { Errors } from '@/dto/ErrorsResponse'
import priceConfigStore from '@/stores/PriceConfigStore'
import { Routes } from '@/router/routes'
import PriceConfigDeleteForm from '@/components/price-config/PriceConfigDeleteForm.vue'
import PriceConfigItems from '@/components/price-config/PriceConfigItems.vue'

@Component({
  components: { PriceConfigItems, PriceConfigDeleteForm },
})
export default class PriceConfigForm extends Vue {
  static localStorageKey = 'priceConfigTab'

  @Prop(Object)
  model: PriceConfig

  priceConfigStore = priceConfigStore
  isShowConfirmDialog: boolean = false
  isPending: boolean = false
  isDisabledBtn: boolean = true
  currenciesOptions: any = {}
  errors: Errors = {}
  currentTab: string = 'preferences'
  tabs = [
    { name: 'preferences', label: 'Настройка' },
    { name: 'values', label: 'Значения' },
  ]

  created() {
    this.currenciesOptions = DictionariesService.getCurrenciesOptions()
    const storedTab = localStorage.getItem(PriceConfigForm.localStorageKey)

    if (storedTab) {
      this.currentTab = storedTab
    }
  }

  get currentCurrency(): Currency | null {
    if (!this.model.currencyCode) {
      return null
    }

    return DictionariesService.currencies[this.model.currencyCode]
  }

  isDisabledTab(tabName: string): boolean {
    return tabName === 'values' && this.model.id === null
  }

  savePriceConfig() {
    this.isPending = true

    this.priceConfigStore
      .savePriceConfig(this.model)
      .then((priceConfig: PriceConfig) => {
        const priceConfigId = priceConfig.id as number

        if (priceConfigId.toString() !== this.$route.params.priceConfigId) {
          this.$router.push({
            name: Routes.priceConfigEdit,
            params: { priceConfigId: priceConfigId.toString() },
          })
        }
      })
      .catch(errors => (this.errors = errors))
      .finally(() => (this.isPending = false))
  }

  @Watch('model')
  setDefaultTab() {
    if (!this.model.id) {
      this.currentTab = 'preferences'
    }
  }

  @Watch('currentTab')
  localSave(currentTab: string) {
    localStorage.setItem(PriceConfigForm.localStorageKey, currentTab)
  }

  @Watch('model', { deep: true })
  watchFields(model: PriceConfig, oldModel: PriceConfig) {
    this.isDisabledBtn = model.id !== oldModel.id
  }
}
